import { __rest } from "tslib";
import React from "react";
import getClass from "../utils/classNames";
var rowKeys = ["start", "center", "end", "top", "middle", "bottom", "around", "between"];

function getRowClassNames(e) {
  var t = [e.className, getClass("row")];

  for (var s = 0; s < rowKeys.length; ++s) {
    var r = rowKeys[s],
        o = e[r];
    o && t.push(getClass("".concat(r, "-").concat(o)));
  }

  return e.reverse && t.push(getClass("reverse")), t.filter(function (e) {
    return e;
  }).join(" ");
}

export function Row(e) {
  var t = e.tagName,
      s = e.children,
      r = __rest(e, ["tagName", "children"]);

  return React.createElement(t || "div", {
    className: getRowClassNames(r),
    children: s
  });
}
export default Row;